import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { SpacerVertical as Component } from './spacer-vertical';
import styles from './styles/styles.module.css';
import type { IDeps, TSpacerVertical } from './models';
import { separator } from './config';

export const SpacerVertical = createWidget<IDeps, TSpacerVertical>({
    styles,
    separator,
})(Component);
